<template>
  <div>
    <Modal
      :visibility="isShowFailModal"
      :title="modalTitle"
      width="296px"
      @click-main-button="handleBtn"
    />
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: 'center' })

const { replacePrevUrl } = useOrderResult()
const { query } = useRoute()
// 토스 결제 실패 리다이렉트 쿼리: code, message, orderId
const { message } = query as Record<string, string>

const modalTitle = ref<string>('')
const isShowFailModal = ref<boolean>(false)

const handleBtn = () => {
  isShowFailModal.value = false
  replacePrevUrl()
}

onMounted(() => {
  modalTitle.value = message || '결제에 실패했습니다'
  isShowFailModal.value = true
})
</script>
